import React from 'react';
import OrderList from '../components/OrderList';

export default function CompletedOrders() {
  return (
    <OrderList
      status="completed"
      title="调度完成"
      desc="调度完成工单的历史记录，用于问题复盘、资料查询与后续业务对账"
    />
  );
}
